import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-guru-badge-dialog',
  standalone: true,
  imports: [MatDialogModule, MatButtonModule],
  templateUrl: './guru-badge-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './guru-badge-dialog.component.scss'
})
export class GuruBadgeDialogComponent {

  private readonly guruUrl = 'https://support.salesmail.com/portal/en/kb/articles/salesmail-guru-stat';

  private dialogRef = inject(MatDialogRef<GuruBadgeDialogComponent>);

  shareBadge(): void {
    window.open(this.guruUrl, '_blank', 'noopener');
    this.dialogRef.close();
  }
}
